export default __webpack_public_path__ + "static/media/herbalife3.20e1d66a.jpg";